<template>
  <StackPageLayout @close="handleClose">
    <template #title> New Cashier </template>

    <div
      class="flex min-h-full flex-col rounded-lg bg-background p-3"
    >
      <CashierForm @submit="handleSubmit" />
    </div>
  </StackPageLayout>
</template>

<script setup lang="ts">
import type { CashierFormOutput } from "@/forms/cashierForm"
import { createCashier } from "@/services/cashiers/createCashier"

const { startLoading, stopLoading } =
  usePageBlockingLoading()
const router = useRouter()

const handleClose = () =>
  router.push({ name: "settingsCashierIndex" })

const handleSubmit = async (params: CashierFormOutput) => {
  startLoading()
  try {
    await createCashier(params)
    toast.success("Cashier created")
    router.push({ name: "settingsCashierIndex" })
  } catch {
    toast.error("Failed to create cashier")
  } finally {
    stopLoading()
  }
}
</script>
